import React from 'react'
import { connect } from 'react-redux'
import BrandActions from '../../Redux/BrandRedux'
import CategoryActions from '../../Redux/CategoryRedux'

class AssignCategory extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      brand_name: props.detail.name,
      brand: {
        brand_id: props.detail.id,
        category_id: props.detail.categories.id
      }
    }
  }

  componentDidMount = () => {
    this.props.getCategory()
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let brand = {...this.state.brand}
    brand[field] = value
    this.setState({ brand })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = {...this.state.brand}
    this.props.createCategoryBrand(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { category } = this.props
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Assign category to a brand</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row' >
            <div className='col-3' >
              <label className='control-label'>For brand</label>
            </div>
            <div className='col-9' >
              <input
                type='text'
                className='form-control'
                disabled
                value={this.state.brand_name}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Category</label>
            </div>
            <div className='col-9'>
              <select className='form-control' onChange={(event) => this._inputChange(event, 'category_id')} >
                <option>--Pick a Category--</option>
                {
                  category.data && category.data.map((item, i) => {
                    return (
                      <option key={i} value={item.id}>{item.name}</option>
                    )
                  })
                }
              </select>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  category: state.category
})

const dispatchToProps = (dispatch) => ({
  createCategoryBrand: (data) => dispatch(BrandActions.createCategoryBrandRequest(data)),
  getCategory: (data) => dispatch(CategoryActions.getCategoryRequest(data))
})

export default connect(stateToProps, dispatchToProps)(AssignCategory)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/AssignCategory.js